import { useState, useEffect } from "react";
import { ApiHelper } from "../utils/apiHelper";

const useAccountInfo = () => {
    const [accountInfo, setAccountInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAccountInfo = async () => {
            try {
                setLoading(true);
                setError(null);

                const response = await ApiHelper.get("/account/info");

                if (response.data.code === "00000") {
                    setAccountInfo(response.data.account);
                } else {
                    throw new Error("Invalid response code");
                }
            } catch (err) {
                console.error("Error fetching account info:", err);
                setError(err.message || "An error occurred");
            } finally {
                setLoading(false);
            }
        };

        fetchAccountInfo();
    }, []);

    return { accountInfo, loading, error };
};

export default useAccountInfo;
